// extracted by mini-css-extract-plugin
export default {"root":"RowLayout3d_root__QumTV","placeHolderShimmer":"RowLayout3d_placeHolderShimmer__JM55+"};